import React from 'react';
import { motion } from 'framer-motion';
import { Nav } from '../components/Nav';
import { Hero } from '../components/Hero';
import { About } from '../components/About';
import { SocialProof } from '../components/SocialProof';
import { Services } from '../components/Services';
import { TheOffer } from '../components/TheOffer';
import { Footer } from '../components/Footer';
const ambientShapes = [{
  size: 380,
  color: '#C4714A',
  opacity: 0.06,
  blur: 90,
  animateX: ['-5%', '12%', '-8%', '15%', '-5%'],
  animateY: ['-3%', '10%', '-12%', '6%', '-3%'],
  duration: 32,
  top: '8%',
  left: '5%'
}, {
  size: 300,
  color: '#7A9E7E',
  opacity: 0.055,
  blur: 80,
  animateX: ['8%', '-10%', '14%', '-6%', '8%'],
  animateY: ['5%', '-8%', '12%', '-10%', '5%'],
  duration: 38,
  top: '20%',
  right: '8%'
}, {
  size: 450,
  color: '#C4714A',
  opacity: 0.04,
  blur: 110,
  animateX: ['0%', '10%', '-12%', '6%', '0%'],
  animateY: ['0%', '-10%', '8%', '-6%', '0%'],
  duration: 44,
  top: '45%',
  left: '20%'
}, {
  size: 220,
  color: '#7A9E7E',
  opacity: 0.07,
  blur: 65,
  animateX: ['-6%', '14%', '-10%', '8%', '-6%'],
  animateY: ['8%', '-14%', '10%', '-8%', '8%'],
  duration: 26,
  top: '65%',
  left: '8%'
}, {
  size: 340,
  color: '#C4714A',
  opacity: 0.05,
  blur: 95,
  animateX: ['6%', '-12%', '10%', '-8%', '6%'],
  animateY: ['-6%', '12%', '-10%', '8%', '-6%'],
  duration: 36,
  top: '35%',
  right: '12%'
}, {
  size: 200,
  color: '#E0D8CF',
  opacity: 0.1,
  blur: 55,
  animateX: ['0%', '-15%', '10%', '-5%', '0%'],
  animateY: ['0%', '12%', '-15%', '10%', '0%'],
  duration: 22,
  top: '80%',
  right: '20%'
}, {
  size: 260,
  color: '#7A9E7E',
  opacity: 0.045,
  blur: 75,
  animateX: ['10%', '-5%', '12%', '-10%', '10%'],
  animateY: ['-8%', '10%', '-5%', '12%', '-8%'],
  duration: 30,
  top: '10%',
  left: '55%'
}];
export function Home() {
  return <div className="min-h-screen bg-background text-ink font-sans selection:bg-terracotta/20" data-id="element-364">
      {/* Page-wide ambient floating shapes — fixed so they stay visible while scrolling */}
      <div className="fixed inset-0 pointer-events-none z-0 overflow-hidden" data-id="element-365">
        {ambientShapes.map((shape, i) => <motion.div key={i} className="absolute rounded-full" style={{
        width: shape.size,
        height: shape.size,
        background: shape.color,
        opacity: shape.opacity,
        filter: `blur(${shape.blur}px)`,
        top: shape.top,
        left: (shape as any).left,
        right: (shape as any).right
      }} animate={{
        x: shape.animateX,
        y: shape.animateY,
        scale: [1, 1.12, 0.92, 1.08, 1]
      }} transition={{
        duration: shape.duration,
        repeat: Infinity,
        ease: 'easeInOut'
      }} data-id="element-366" />)}
      </div>

      <div className="relative z-10" data-id="element-367">
        <Nav data-id="element-368" />
        <main data-id="element-369">
          <Hero data-id="element-370" />
          <About data-id="element-371" />
          <SocialProof data-id="element-372" />
          <Services data-id="element-373" />
        </main>
        <Footer data-id="element-374" />
      </div>
    </div>;
}